<template>
    <div class="ku-location">
        <van-field clearable v-model="key" @input="schoolNameChange">
            <template #button>
                <van-button size="small" type="primary" @click="setShop">确定</van-button>
            </template>
        </van-field>
        <div class="select">
            <div v-for="(item, index) in list" :key="index" @click="setKey(item)">
                <span>{{ item.title }}</span>
                <label>{{ item.address }}</label>
            </div>
        </div>
        <div class="add"><span>提前点餐技巧：</span>可以直接输入店铺地址或周边地标</div>
        <div class="shop_list" v-if="shop_list.length !== 0">
            <div class="t1">提前点餐 / 快捷选择</div>
            <div class="s1" v-for="(v, k) in shop_list" :key="k" @click="onGoods(v)">
                <div class="span">
                    <span>{{ v.shop_name }}</span>
                    <label>{{ v.address }}</label>
                </div>
                <van-image round fit="cover" :src="v.image" />
                <div class="zz" v-if="v.ts_switch !== 1"></div>
                <div class="zz_sw" v-if="v.ts_switch !== 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Image as VanImage, Field, Button, Notify, Cell, CellGroup, Icon, Dialog } from 'vant';
import router from "@/router";
import {getCookie, setCookie} from "@/utils/auth";
import {VueJsonp} from 'vue-jsonp';

Vue.use(VanImage).use(Field).use(Button).use(Notify).use(Cell).use(CellGroup).use(Icon).use(Dialog);
Vue.use(VueJsonp);

export default {
    data() {
        return {
            key: '',
            key_check: false,
            region: '中国',
            list: [],
            shop_list: [],
            amap: [],
            address: {
                lat: '',
                lng: '',
                address: '',
            }
        };
    },
    mounted() {
        let key_check = getCookie('key_check');
        let address = getCookie('address')
        if (key_check) {
            this.key_check = key_check
            this.key = address
            this.key_check = true
            this.address.lat = getCookie('lat');
            this.address.lng = getCookie('lng');
            this.address.address = address
            if (key_check === "1") {
                this.setShop()
            }
        }
        this.geocoder()
        this.getShop()
    },
    methods: {
        // 设置地址
        setAddress(e) {
            setCookie('lat', e.lat)
            setCookie('lng', e.lng)
            setCookie('address', e.address)
            setCookie('address_id', 0)
            // this.$API.sendLatLng({
            //     lat: e.lat,
            //     lng: e.lng
            // }).then(() => {
                router.push('/shop')
            // })
        },
        getShop() {
            this.$API.getShopLs().then(res => {
                return res.data;
            }).then(res => {
                this.shop_list = res.data;
            })
        },
        geocoder() {
            const that = this;
            let lat = getCookie('lat')
            let lon = getCookie('lng')
            this.$jsonp("https://apis.map.qq.com/ws/geocoder/v1/",{
                location: lat + ',' + lon,
                key: "TDJBZ-YZMCF-QIRJG-JUA4K-3ELO5-HNBFD",
                output: 'jsonp'
            }).then(res => {
                console.log(res)
                if (res.status === 0) {
                    that.region = res.result.address_component.city
                }
                console.log(that.region)
            }).catch(err => {
                console.log("catch", err);
            });
        },
        schoolNameChange() {
            const that = this;
            const schoolName = this.key;
            that.address = {
                lat: '',
                lng: '',
                address: '',
            }
            this.$jsonp("https://apis.map.qq.com/ws/place/v1/suggestion/",{
                region: that.region,
                keyword: schoolName,
                key: "TDJBZ-YZMCF-QIRJG-JUA4K-3ELO5-HNBFD",
                output: 'jsonp'
            }).then(res => {
                that.list = res.data;
            }).catch(err => {
                console.log("catch", err);
            });

        },
        setKey(e) {
            this.key = e.title
            this.list = []
            this.amap = e
            this.address.lat = e.location.lat
            this.address.lng = e.location.lng
            this.address.address = e.title
        },
        setShop() {
            let that = this
            if (that.address.lat.length === 0) {
                Notify('请先选择地址')
                return false;
            }
            this.$API.getShopList({s_address: this.address}).then(res => {
                let data = res.data.data;
                if (data.count >= 1) {
                    this.setAddress(this.address)
                } else {
                    Notify('抱歉！您所选的区域没有商家')
                }
            })
        },
        onGoods(obj) {
            if (obj.ts_switch !== 1) {
                return false;
            }

            Dialog.confirm({
                title: '消息提醒',
                message: '确认打开店铺(' + obj.shop_name + ')吗？',
            }).then(() => {
                this.$API.getShopInfo({shop_id: obj.id}).then(res => {
                    return res.data
                }).then(res => {
                    this.$router.push({
                        path: res.data.checkTime ? 'goods_fast' : 'goods',
                        query: {
                            shop_id: obj.id
                        }
                    })
                });
            });
        }
    },
};
</script>

<style lang="less" scoped>
.ku-location {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #50AFA7;
    .add {
        font-size: 24px;
        line-height: 80px;
        color: #ffffff;
        font-weight: normal;
        font-family: 'Microsoft YaHei', serif;
        span {
            color: #FFF100;
        }
    }
    .van-cell-group {
        background: none;
        padding: 10px 10px;
        position: relative;
        &:after {
            display: none;
        }
        .van-cell {
            background: none;
            border-bottom: 1px solid #EFEA3C;
            &:after {
                display: none;
            }
            .van-cell__value {
                color: #FFF100;
                text-align: center;
            }
            &:nth-child(1) {
                border-top: 1px solid #EFEA3C;
            }
        }
        .van-icon {
            position: absolute;
            right: 5px;
            top: 10px;
            background: #F8B62D;
            color: #ffffff;
            border-radius: 50%;
            font-size: 24px;
            padding: 3px;
        }
    }
    .van-address-list__bottom {
        background: none;
    }
    .van-field {
        margin: 180px 60px 0 60px;
        width: auto;
        /deep/ .van-field__clear {
            margin-right: 8px;
        }
    }
    .select {
        background: #fff;
        margin: 0 60px;
        position: absolute;
        z-index: 9;
        div {
            overflow: hidden;
            height: 60px;
            line-height: 60px;
            text-align: left;
            padding: 0 30px;
            span {
                font-size: 28px;
            }
            label {
                color: #969799;
                padding-left: 5px;
            }
        }
    }
    .shop_list {
        margin-top: 80px;
        .t1 {
            font-size: 38px;
            line-height: 100px;
            letter-spacing: 2px;
            font-weight: bold;
            color: #fff;
        }
        .s1 {
            position: relative;
            background: white;
            width: 480px;
            height: 80px;
            border-radius: 15px;
            margin: 12px auto;
            padding: 20px 30px;
            .span {
                width: 320px;
                padding-top: 8px;
                line-height: 40px;
                float: left;
                text-align: left;
                font-size: 32px;
                span, label {
                    display: block;
                }
                label {
                    line-height: 30px;
                    font-size: 24px;
                    color: #666;
                }
            }
            .van-image {
                width: 80px;
                height: 80px;
                float: right;
            }
            .zz {
                position: absolute;
                width: 100%;
                height: 100%;
                background: #000;
                border-radius: 15px;
                opacity: 0.5;
                left: 0;
                top: 0;
            }
            .zz_sw {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: url('../../assets/3.png') no-repeat 70%;
                background-size: auto 80%;
            }
        }
    }
}
</style>
